/**
 * Converts a track to string of format (origin, if present) name
 * @param {Object} track a track object
 * @returns a string with track information
 */
export default function trackToString(track) {
    return `${track.origin ? `${track.origin} ` : ""}${track.name}`
}